import React from "react";
import { useSelector } from "react-redux";
import { GeneralState } from "../Redux";
import AuthenticationRouter from "./Authentication";
import LoggedInUserRouter from "./LoggedInUserRouter";

const Router = () => {
  const isUserSignedIn = useSelector(GeneralState.Selectors.selectIsUserLoggedIn);

  return isUserSignedIn ? <LoggedInUserRouter /> : <AuthenticationRouter />;
};

export default Router;
